import { getFundQuote } from '../../api/fund.api';
import { FundQuoteData } from '../../types/fundsummary.type';
import useFundResource, { FundResourceResult } from './useFundResource';

const useFundQuote = (
  ric: string = '',
  token: string = '',
  saleInCountryCode: string = 'US',
): FundResourceResult<FundQuoteData> =>
  useFundResource<FundQuoteData>(getFundQuote, ric, token, saleInCountryCode);

export default useFundQuote;
